import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class DocumentsTreeClaimDetail extends BaseModel {
    @Expose() label = "";
    @Expose() placeHolder = "";
    @Expose() maxlen = 10;
}
